<template>
<b-row>
    <b-col cols="12">
      
      <b-btn class="return-btn" variant="primary" @click.stop="returnhome">Return</b-btn>

      <b-jumbotron id="bulletin">
        <template slot="header">
          <font class="post-title" size=8pt>{{post.title}}</font>
        </template>
        
        <template slot="lead">
          <font size="3" color="grey">
          Author: {{post.Author}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Position: {{post.position}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Date Posted: {{post.DateTime}}
          </font><br><br><br>
          
          
          <div class="post-wrap">
            {{post.details}}
          </div>
        </template>
        
        <b-btn class="edit-btn" variant="success" @click.stop="editpost(key)">Edit</b-btn>
        <b-btn class="delete-btn" variant="danger" @click.stop="deletepost(key)">Delete</b-btn>
      </b-jumbotron>
    </b-col>
  </b-row>
</template>

<script>

import firebase from '../Firebase'
import router from '../router/index.js'

export default {
  name: 'ShowPost',
  data () {
    return {
      key: '',
      post: {},
      scrolled: false
    }
  },
  created () {
    const ref = firebase.firestore().collection('posts').doc(this.$route.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.key = doc.id;
        this.post = doc.data();
      } else {
        alert("No such document!");
      }
    });
  },
  methods: {
    editpost (id) {
      router.push({
        name: 'EditPost',
        params: { id: id }
      })
    },
    deletepost (id) {
      firebase.firestore().collection('posts').doc(id).delete().then(() => {
        router.push({
          name: 'Dashboard'
        })
      }).catch((error) => {
        alert("Error removing document: ", error);
      });
    },
    returnhome (){
      router.push({
        name: "Dashboard"
      })
    }
  }
}
</script>

<style>
  .jumbotron {
    padding: 2rem;
  }
  .post-title {
    font-variant: small-caps;
  }
  .edit-btn {
    margin-right: 20px;
    width: 70px;
  }
  .delete-btn {
    
    width: 70px;
  }
  .post-wrap {
  border: 1px ;
  padding: 1rem;
  width: 50%;
  margin: 0 auto;
  white-space: pre-wrap;
}
.return-btn {
  margin-bottom: 20px;
}
</style>